<div>
	<!-- This component has no visual elements. -->
</div>